import { articoloBE } from './../models/sync.model';


export class InitCatalogo {
  static readonly type= '[catalogo] initCatalogo';
  constructor() {}
}


export class SetCatalogo{
  static readonly type= '[catalogo] setta il catalogo';
  constructor(public articoli: articoloBE[]) {  }
}
